import { Background, Controls, type Edge, type Node, ReactFlow } from "@xyflow/react";
import type { Locale, SiteState } from "../shared/project-state";

export function BlueprintMap({ state, locale }: { state: SiteState; locale: Locale }) {
  const nodes: Node[] = state.stages.map((stage, index) => ({
    id: stage.id,
    position: { x: index * 205, y: index % 2 === 0 ? 24 : 128 },
    data: {
      label: `${stage.id} · ${locale === "zh-CN" ? stage.nameZh : stage.nameEn}\n${stage.progress}%`,
    },
    className: stage.id === state.currentStage ? "flow-node flow-node-active" : "flow-node",
  }));
  const edges: Edge[] = state.stages.slice(1).map((stage, index) => ({
    id: `${state.stages[index].id}-${stage.id}`,
    source: state.stages[index].id,
    target: stage.id,
    animated: stage.id === state.currentStage,
  }));

  return (
    <div
      className="flow-shell"
      role="region"
      aria-label={locale === "zh-CN" ? "L0-L5 蓝图地图" : "L0-L5 blueprint map"}
    >
      <ReactFlow
        nodes={nodes}
        edges={edges}
        fitView
        nodesDraggable={false}
        nodesConnectable={false}
        elementsSelectable={false}
      >
        <Background gap={20} />
        <Controls showInteractive={false} />
      </ReactFlow>
    </div>
  );
}
